import { createContext, useContext } from 'react';

type AdaChatContext = boolean;

const adaChatContext = createContext<AdaChatContext>(null);

type Props = {
    isChatEnabled: boolean;
};

export const AdaChatContext: React.FC<Props> = ({ isChatEnabled, children }) => (
    <adaChatContext.Provider value={isChatEnabled}>{children}</adaChatContext.Provider>
);

export const useAdaChatContext = () => useContext(adaChatContext);
